<template>
    <div class="mvt-listproperty list-card">
        <mvtShifter ref="shifter" @scroll="scroll" :center="true">
            <mvtCardProperty :cardFilter="cardFilter" v-for="item in list" :theme="'style3'" :key="item.propertyId" :showLeadButton="showLeadButton" :tracked="false" :query="query" :data="item" @selectItem="selectItem" cardParent="carousel" />
        </mvtShifter>
        <slot></slot>
    </div>
</template>
<script src="./mvt-listproperty.js"></script>

<style lang="scss">
@use "./mvt-listproperty.scss" as *;
</style>
